import { graphql, useLazyLoadQuery } from "react-relay";
import { TodoTeamsPopoverQuery } from "./__generated__/TodoTeamsPopoverQuery.graphql";
import { TeamSelectPopover } from "widgets/src/TeamSelectPopover";

export function TodoTeamsPopover(props: {
  selectedTeamIds: string[];
  setSelectedTeamIds: (selectedTeamIds: string[]) => void;
  visible: boolean;
  onClose: () => void;
  fetchKey: string;
}) {
  const data = useLazyLoadQuery<TodoTeamsPopoverQuery>(
    graphql`
      query TodoTeamsPopoverQuery($visible: Boolean!) {
        storeViewer @include(if: $visible) {
          teams {
            id
            ...TeamSelectList_Team
          }
        }
      }
    `,
    { visible: props.visible }
  );

  const teams = data.storeViewer?.teams ?? [];
  return (
    <TeamSelectPopover
      onItemPress={(itemId, selected) => {
        props.setSelectedTeamIds(
          selected
            ? props.selectedTeamIds.filter((id) => id !== itemId)
            : [...props.selectedTeamIds, itemId]
        );
      }}
      onSelectAll={() => {
        props.setSelectedTeamIds([]);
      }}
      teams={teams}
      teamIds={props.selectedTeamIds}
      visible={props.visible}
      onClose={props.onClose}
    />
  );
}
